import React from 'react'
import { Link, useForm, usePage } from '@inertiajs/react'
import AuthLayout from '../../components/AuthLayout'
import loginBg from '../../../assets/images/IMAGEM 11 - ACESSO RESTRITO HA.jpg'

export default function Login() {
  const { errors } = usePage().props
  const { data, setData, post, processing } = useForm({
    'user[email]': '',
    'user[password]': '',
    'user[remember_me]': '0'
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    post('/users/sign_in', { forceFormData: true })
  }

  return (
    <AuthLayout backgroundImage={loginBg}>
      <div className="text-center text-white">
        <h2 className="text-2xl font-bold mb-6">Faça seu login:</h2>

        <form onSubmit={handleSubmit}>
          {errors?.email && (
            <div className="mb-4 text-red-300 text-sm">{errors.email}</div>
          )}
          <div className="mb-4">
            <input
              type="email"
              value={data['user[email]']}
              onChange={(e) => setData('user[email]', e.target.value)}
              placeholder="Digite seu e-mail"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoFocus
              autoComplete="email"
            />
          </div>

          <div className="mb-4">
            <input
              type="password"
              value={data['user[password]']}
              onChange={(e) => setData('user[password]', e.target.value)}
              placeholder="Digite sua senha"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoComplete="current-password"
            />
          </div>

          <div className="mb-4 flex items-center justify-center">
            <input
              type="checkbox"
              id="remember"
              checked={data['user[remember_me]'] === '1'}
              onChange={(e) => setData('user[remember_me]', e.target.checked ? '1' : '0')}
              className="w-4 h-4 rounded border-gray-300 text-brand-light focus:ring-brand-light"
            />
            <label htmlFor="remember" className="ml-2 text-sm">
              Lembrar de mim
            </label>
          </div>

          <div className="mb-6 space-y-2 text-sm">
            <Link href="/users/sign_up" className="block text-white/90 hover:text-white underline underline-offset-2 decoration-white/40 hover:decoration-white transition-colors">
              Ainda não é cadastrado? criar conta
            </Link>
            <Link href="/users/password/new" className="block text-white/90 hover:text-white underline underline-offset-2 decoration-white/40 hover:decoration-white transition-colors">
              Esqueci minha senha
            </Link>
          </div>

          <button
            type="submit"
            disabled={processing}
            className="w-1/2 h-12 bg-brand-light hover:bg-brand-dark text-white font-medium rounded-lg transition-colors disabled:opacity-50"
          >
            {processing ? 'Acessando...' : 'Acessar'}
          </button>
        </form>
      </div>
    </AuthLayout>
  )
}
